import React from "react";
import { MEMBERSHIP_PROCESS_STEPS } from "@/data/maintenancePlans";

export default function MembershipProcessSteps() {
  return (
    <section className="section-pad bg-white" id="how-it-works" data-testid="membership-process">
      <div className="container-br">
        <div className="max-w-2xl mb-8">
          <div className="br-eyebrow">How It Works</div>
          <h2 className="br-headline text-3xl sm:text-4xl mt-3">How the Membership Process Works</h2>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-4 lg:gap-2 relative">
          {MEMBERSHIP_PROCESS_STEPS.map((step, idx) => (
            <div key={step.title} className="relative" data-testid={`process-step-${idx + 1}`}>
              <div className="bg-br-paper border border-gray-200 rounded p-5 h-full">
                <div className="flex items-center gap-2 mb-2">
                  <div className="shrink-0 w-7 h-7 rounded-full bg-br-bronze text-white font-bold flex items-center justify-center text-xs">{idx + 1}</div>
                  <div className="font-display tracking-widest uppercase text-xs text-br-bronze">Step {idx + 1}</div>
                </div>
                <div className="font-display text-base tracking-wider uppercase mb-2">{step.title}</div>
                <p className="text-xs text-gray-700 leading-relaxed">{step.body}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
